import React                                   from 'react';
import classnames                              from 'classnames';
import { materialThickness as defaultOptions } from 'pu-data/SelectOptions';
import { materialThickness as tooltip }        from 'pu-data/Tooltips';
import TextComponentGroup                      from 'pu-react/components/TextComponentGroup';

const MaterialThicknessFlex = (props) => {
  if (!props.show) { return null; }

  const name = 'material_thickness';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponentGroup
      label={props.label}
      name={name}
      inputId={props.inputId}
      value={props.parameters[name]}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      className={classnames('material-thickness', props.className)} />
  );
};

MaterialThicknessFlex.defaultProps = {
  options : defaultOptions,
  label   : 'Rigid<br class="d-none d-lg-block" /> Thickness',
  show    : true,
  required: true,
};

export default MaterialThicknessFlex;
